import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

export default function PageHero({ eyebrow, lines, sub, image, alt = "", children }) {
  return (
    <section className="relative overflow-hidden border-b border-pine/10">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:py-24">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="eyebrow"
          >
            {eyebrow}
          </motion.p>
          <MaskLines
            as="h1"
            lines={lines}
            delay={0.1}
            className="mt-4 font-serif text-4xl leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl"
          />
          {sub && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="mt-6 max-w-xl text-base leading-relaxed text-bodytext sm:text-lg"
            >
              {sub}
            </motion.p>
          )}
          {children && (
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.65 }}
              className="mt-8"
            >
              {children}
            </motion.div>
          )}
        </div>
        {image && (
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="overflow-hidden rounded-[2.5rem] shadow-[0_24px_60px_rgba(45,90,70,0.18)]">
              <motion.img
                src={image}
                alt={alt}
                initial={{ scale: 1.12 }}
                animate={{ scale: 1 }}
                transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
                className="h-72 w-full object-cover sm:h-96 lg:h-[460px]"
              />
            </div>
            <div
              aria-hidden="true"
              className="absolute -bottom-4 -left-4 -z-10 h-full w-full rounded-[2.5rem] bg-blush"
            />
          </motion.div>
        )}
      </div>
    </section>
  );
}
